import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const NoticesPage = lazy(() => import('../pages/notices/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/notices',
    element: <NoticesPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
